import { useSyncExternalStore } from "react";

// Pila de <dialog> modales abiertos (los abre `Modal` en ui.tsx). Un modal
// deja inerte todo lo que está fuera de él, así que los avisos emergentes
// (Avisos.tsx) se montan dentro del modal de arriba para seguir siendo
// clicables; fuera de un modal van al <body>.
let pila: HTMLDialogElement[] = [];
const oyentes = new Set<() => void>();
const avisar = () => oyentes.forEach((f) => f());

export function apilarDialogo(d: HTMLDialogElement) {
  pila = [...pila, d];
  avisar();
}
export function desapilarDialogo(d: HTMLDialogElement) {
  pila = pila.filter((x) => x !== d);
  avisar();
}
export function useDialogoSuperior(): HTMLDialogElement | null {
  return useSyncExternalStore(
    (f) => {
      oyentes.add(f);
      return () => oyentes.delete(f);
    },
    () => pila[pila.length - 1] ?? null,
  );
}
